import { RecommendationsTitle, RecommendationsSubtitle, RecommendationsTitleTag, RecommendationsSideButton, RecommendationsFooter, RecommendationsSeeMoreCard, withCarouselContainer } from '@recommendations-fe/commons';
import _jsx2 from '@babel/runtime/helpers/jsx';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { useRef, useState, useEffect } from 'react';
import 'prop-types';
import classNames from 'classnames';
import { CarouselSnapped as CarouselSnapped$1, CarouselSnappedSlide } from '@andes/carousel-snapped';
import { namespaceRecommendations } from '@recommendations-fe/commons/namespaces';
import { measuringFlag, measuringHeight } from '@polycard/card';
import { jsxs, jsx } from 'react/jsx-runtime';
const _excluded = ["className", "classnameFromResponse", "classNamesMap", "classNamesIndexMap", "slidesPerView", "Card", "cardProps", "IconFactory", "buttonSize", "hideRebates", "onItemClick", "onBookmarkClick", "onTitleTagIconClick", "bookmarkedItems", "bookmarkText", "disableHover", "fixedHeight", "arrowsSize", "isPolycard", "cardType", "paginationConfig", "carouselSpacing", "onResize", "initialSlide", "minItemsToShow"];
const namespace = "".concat(namespaceRecommendations, "-carousel-snapped");
const isMeasurement = reference => reference && reference.querySelector('.andes-carousel-snapped');
/* istanbul ignore next */
const measuring = reference => {
  // Target elements
  const carousel = reference.querySelector('.andes-carousel-snapped');
  const card = reference.querySelector('.andes-carousel-snapped__slide');

  // Measurings
  const carouselHeight = carousel.getBoundingClientRect().height;
  const carouselPaddingTop = parseFloat(window.getComputedStyle(carousel).paddingTop) || 0;
  const carouselPaddingBottom = parseFloat(window.getComputedStyle(carousel).paddingBottom) || 0;
  const cardMarginBottom = parseFloat(window.getComputedStyle(card).marginBottom) || 0;
  return carouselHeight - carouselPaddingTop - carouselPaddingBottom - cardMarginBottom;
};
const CarouselSnapped = _ref => {
  let {
      className = '',
      classnameFromResponse = '',
      classNamesMap = {},
      classNamesIndexMap = {},
      slidesPerView = 5,
      Card,
      cardProps,
      IconFactory,
      buttonSize = 'medium',
      hideRebates = false,
      onItemClick,
      onBookmarkClick,
      onTitleTagIconClick,
      bookmarkedItems,
      bookmarkText,
      disableHover,
      fixedHeight,
      arrowsSize = 'large',
      isPolycard = false,
      cardType,
      paginationConfig = null,
      carouselSpacing = 12,
      onResize = null,
      initialSlide,
      minItemsToShow
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Card Height, Arrow Visible, Hover Disable
  const carouselRef = useRef();
  const [isJsLoaded, setIsJsLoaded] = useState(false);
  /* istanbul ignore next */
  useEffect(() => {
    if (measuringFlag(carouselRef.current, cardType)) {
      const maxCardHeight = measuringHeight(carouselRef.current, cardType);
      if (onResize) {
        onResize(maxCardHeight);
      }
    }
    setIsJsLoaded(true);
  }, [carouselRef]);

  // Misc components props

  const {
    items,
    title,
    titleWithIcons,
    titleTag,
    subtitle,
    viewMoreAction,
    footer,
    href,
    cardSeeMore = null
  } = rest;
  const Slides = arItems => {
    const internaSlide = arItems.map((item, index) => {
      const id = isPolycard ? item.metadata.id : item.id;
      const CardToUse = item.CustomCard || Card;
      // eslint-disable-next-line security/detect-object-injection
      const classNameFromMap = classNamesMap[id];
      /* eslint-disable-next-line security/detect-object-injection */
      const classNameFromIndex = classNamesIndexMap[index];
      return /*#__PURE__*/_jsx2(CarouselSnappedSlide, {}, "recommendations-".concat(id), /*#__PURE__*/jsx(CardToUse, _objectSpread(_objectSpread(_objectSpread({}, cardProps), item), {}, {
        classNameFromMap: classNameFromMap,
        classNameFromIndex: classNameFromIndex,
        IconFactory: IconFactory,
        onItemClick: onItemClick,
        onBookmarkClick: onBookmarkClick,
        bookmarkedItems: bookmarkedItems,
        bookmarkText: bookmarkText,
        hideRebates: hideRebates,
        disableHover: disableHover || !isJsLoaded,
        number: index
      })));
    });
    // This is neccesary because carousel snapped isn't null safe
    if (cardSeeMore) {
      internaSlide.push( /*#__PURE__*/_jsx2(CarouselSnappedSlide, {}, "recommendations-see-more", /*#__PURE__*/jsx(RecommendationsSeeMoreCard, _objectSpread({}, cardSeeMore))));
    }
    return internaSlide;
  };
  return items && (items.length >= slidesPerView || items.length >= minItemsToShow) && /*#__PURE__*/jsxs("div", {
    className: classNames(namespace, className, classnameFromResponse, {
      ["".concat(namespace, "--fixed-height")]: fixedHeight
    }),
    ref: carouselRef,
    children: [title && /*#__PURE__*/_jsx2("div", {
      className: "".concat(namespace, "__header")
    }, void 0, /*#__PURE__*/_jsx2("div", {
      className: "".concat(namespace, "__header-titles")
    }, void 0, /*#__PURE__*/_jsx2(RecommendationsTitle, {
      title: title,
      titleWithIcons: titleWithIcons,
      href: href,
      IconFactory: IconFactory
    }), subtitle && /*#__PURE__*/_jsx2(RecommendationsSubtitle, {
      text: subtitle.text,
      url: subtitle.url,
      IconFactory: IconFactory,
      advertisingLabel: subtitle.advertising_label,
      accessibilityText: title
    }), titleTag && /*#__PURE__*/_jsx2(RecommendationsTitleTag, {
      text: titleTag.text,
      values: titleTag.values,
      styles: titleTag.styles,
      IconFactory: IconFactory,
      onTitleTagIconClick: onTitleTagIconClick
    })), viewMoreAction && /*#__PURE__*/_jsx2("div", {}, void 0, /*#__PURE__*/_jsx2(RecommendationsSideButton, {
      id: viewMoreAction.id,
      target: viewMoreAction.target,
      label: viewMoreAction.label,
      buttonSize: buttonSize,
      IconFactory: IconFactory
    }))), /*#__PURE__*/_jsx2(CarouselSnapped$1, {
      strictBoundaries: false,
      srLabel: title,
      arrows: isJsLoaded && {
        size: arrowsSize,
        visibility: 'always'
      },
      spacing: carouselSpacing,
      slidesPerView: slidesPerView,
      pagination: paginationConfig,
      initialSlide: initialSlide
    }, void 0, Slides(items)), footer && /*#__PURE__*/_jsx2(RecommendationsFooter, {
      footerText: footer.text,
      href: footer.link,
      IconFactory: IconFactory
    })]
  });
};
CarouselSnapped.defaultProps = {
  measuringFlag: isMeasurement,
  measuringHeight: measuring
};
var RecommendationsCarouselSnappedWithoutContainer = CarouselSnapped;
const RecommendationsCarouselSnapped = withCarouselContainer(RecommendationsCarouselSnappedWithoutContainer);
export { RecommendationsCarouselSnapped, RecommendationsCarouselSnappedWithoutContainer };
